import { render, staticRenderFns } from "./DepartmentHelpList.vue?vue&type=template&id=5f158a2f&"
import script from "./DepartmentHelpList.vue?vue&type=script&lang=js&"
export * from "./DepartmentHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports